import { AddOn } from '../types/addOn.types';

// Monthly
export const FEE_AMOUNT_M_FLAT = 160;
export const FEE_AMOUNT_M_PER_UNIT = 60;
export const FEE_AMOUNT_M_ADDON = 500;

// Annual
// You can find the rates in stripe dashboard > product > "Pro".
export const FEE_AMOUNT_Y_FLAT = 1560;
export const FEE_AMOUNT_Y_PER_UNIT = 600;
export const FEE_AMOUNT_Y_ADDON = 200;

export const getAmountFlat = (isAnnual: boolean) => (
  isAnnual ? FEE_AMOUNT_Y_FLAT / 12 : FEE_AMOUNT_M_FLAT
);

export const getAmountAddon = (isAnnual: boolean) => (
  isAnnual ? FEE_AMOUNT_Y_ADDON : FEE_AMOUNT_M_ADDON
);

export const getAmountPerUnit = (isAnnual: boolean) => (
  isAnnual ? FEE_AMOUNT_Y_PER_UNIT / 12 : FEE_AMOUNT_M_PER_UNIT
);

export const getExpectedStandardFee = (billing: { nbMakers: number }, addOns: AddOn[], isAnnual: boolean) => (
  getAmountFlat(isAnnual) + billing.nbMakers * getAmountPerUnit(isAnnual) + addOns.length * getAmountAddon(isAnnual)
);
